import customSliderBackground from "../../utils/customSliderBackground.js";
import yyMainFeature from "../widgets/yyMainFeature.js";

import customCardWidget from "../../utils/customCardWidget.js";

import yyBannerWidget from "../widgets/yyBannerWidget.js";
import customSocialIcons from "../../utils/customSocialIcons.js";
import customSocialFeedImages from "../../utils/customSocialFeedImages.js";

import * as utils from "../../utils/utils.js";

let themeName;
let themeURL;

// -------------------------
// HEADER
function createHeader(sparkThemeConfig) {
  themeName = sparkThemeConfig[1].navItemName;
  themeURL = sparkThemeConfig[1].navItemUrl;

  const themeHeading = "yesterYear-header";
  $(".header").addClass(themeHeading);

  const headerStructure = `
    <div class="${themeHeading}InnerContent">
      <div class="top-bar-items">
        <div class="inner-content">
        <div class="search-container"></div>
        </div>
      </div>
      <div class="midd-bar">
        <div class="inner-content">
          <div class="right-panel">
            <div class="panel-icons"></div>
            <a class="ticket-container"></a>
          </div>
        </div>
      </div>
      <div class="bottom-bar">
        <div class="inner-content"></div>
      </div>
    </div>`;

  const svgTicket = `
    <svg xmlns="http://www.w3.org/2000/svg" id="ticket-shape" viewBox="0 0 47.26 13.23">
      <g id="ticket-shape" data-name="Layer_1">
        <path class="cls-1"
          d="M44.47,6.62c0,1.54,1.25,2.79,2.79,2.79v2.8c0,.57-.46,1.02-1.02,1.02H1.02c-.57,0-1.02-.45-1.02-1.02v-2.8c1.54,0,2.79-1.25,2.79-2.79S1.54,3.82,0,3.82V1.02C0,.46.45,0,1.02,0h45.22c.56,0,1.02.46,1.02,1.02v2.8c-1.54,0-2.79,1.25-2.79,2.8Z" />
      </g>
    </svg>`;

  $(`.${themeHeading}`).append(headerStructure);

  const yyTopLinks = $("#static-top-links");
  const headerSearch = $(`.${themeHeading} .yester-year-content .searchBox`);
  const weatherWidget = $(
    `.${themeHeading} .yester-year-content #weatherBugWidget`
  );
  const headerCart = $(`.${themeHeading} .yester-year-content .viewcart`);
  const headerToggle = $(`.${themeHeading} .mobile-nav-toggle`);
  const headerNav = $(`.${themeHeading} #mainNavigation`);
  const headerLogo = $(`.${themeHeading} .header-logo`);
  const headerTicketText = $(`.${themeHeading} .yYTicket`).text();
  const headerTicketUrl = $(`.${themeHeading} .yYTicket`).attr("href");

  $(`.${themeHeading} .top-bar-items .inner-content .search-container`).append(
    headerSearch
  );
  $(`.${themeHeading} .midd-bar .right-panel .panel-icons`).prepend(
    headerToggle
  );
  $(`.${themeHeading} .midd-bar .right-panel .panel-icons`).prepend(headerCart);
  $(`.${themeHeading} .midd-bar .right-panel .ticket-container`).prepend(
    svgTicket
  );
  $(`.${themeHeading}InnerContent .top-bar-items .inner-content`).prepend(
    yyTopLinks
  );

  $(headerLogo).attr("aria-label", `${themeName}`);
  $(headerLogo).attr("href", `${themeURL}`);
  $(`.${themeHeading} .midd-bar .right-panel .ticket-container`).append(
    `<span class="ticket-button">${headerTicketText}</span>`
  );
  $(`.${themeHeading} .midd-bar .right-panel .ticket-container`).attr({
    href: headerTicketUrl,
    "aria-label": `${headerTicketText}`,
  });
  $(`.${themeHeading} .midd-bar .right-panel .panel-icons`).prepend(
    weatherWidget
  );
  $(`.${themeHeading} .bottom-bar .inner-content`).prepend(
    headerLogo,
    headerNav
  );
  $(headerCart).clone().prependTo(".mobile-menu-container .mobile-menu-header");

  utils.removeOldHeader(themeHeading);
  utils.customizeSearchBar(themeHeading, "searchBox", "Search Website");
  utils.customWeatherWidget();
}

// -------------------------
// HOMEPAGE CONTENT
function createContent() {
  customSliderBackground(
    "yySliderBackground",
    yySliderBackgroundOpts,
    "yesterYear-content"
  );
  yyMainFeature();
  customCardWidget("yyCardWidget", yyCardWidgetOpts);
  yyBannerWidget();
  customSocialIcons("yySocialIcons", yySocialIconsOpts, 5);
  customSocialFeedImages("yySocialFeedImages", yySocialFeedImagesOpts, 8);

  $(".content").empty();
  $(".content").addClass("yesterYear-content");
  const contentStructure = `
    <div class="tier-1-container">
    <div class="inner-content"></div>
  </div>

  <div class="tier-2-container">
    <div class="inner-content"></div>
  </div>

  <div class="tier-3-container">
    <div class="inner-content"></div>
  </div>

  <div class="tier-4-container">
    <div class="inner-content"></div>
  </div>

  <div class="tier-5-container">
    <div class="inner-content">
      <div class="wrapper-signup">
        <img src="${FULLCLIENTTHEMEPATH}images/yesteryear/email-signup-abstract.png" alt="Email Newsletter" />
        <div class="signup-content">
          <div class="signup-text">
            <span>Stay Up To Date With The Past</span>
            <span>Email Newsletter</span>
          </div>
          <div class="signup-button">
            <a href="${signupUrl}" class="button">Sign Up Now</a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="tier-6-container">
    <div class="inner-content"></div>
  </div>
  `;

  $(".yesterYear-content").append(contentStructure);

  const yySlider = $("#yyMainFeature");
  const yyCards = $("#yyCardWidget");
  const yyBanners = $("#yyBannerWidget");
  const yySponsors = $("#sponsorWidgetContainer");
  const yySocial = $("#yySocialSection");
  const socialIcons = $("#yySocialIcons");
  const yySocialWidget = $("#yySocialFeedImages");

  $(".yesterYear-content .tier-1-container .inner-content").append(yySlider);
  $(".yesterYear-content .tier-2-container .inner-content").append(yyCards);
  $(".yesterYear-content .tier-3-container .inner-content").append(yyBanners);
  $(".yesterYear-content .tier-4-container .inner-content").append(yySponsors);
  $(".yesterYear-content .tier-6-container .inner-content").append(yySocial);
  $(
    ".yesterYear-content .tier-6-container .inner-content .yySocialSection .icons-wrap"
  ).append(socialIcons);

  $(".yesterYear-content .tier-6-container .inner-content").append(
    yySocialWidget
  );

  utils.showContent("yesterYear-content");
  $(".afterContent").remove();
}

// -------------------------
// FOOTER
function createFooter() {
  const footerClass = "yesterYearFooter";

  $(".footer").addClass(footerClass);
  const footerStructure = `
      <div class="section-a">
          <a class="yesteryear-logo" 
          href="${themeURL}" 
          aria-label="${themeName}">
          </a>
      </div>
      <div class="section-b"></div>
      <div class="section-c"></div>`;

  const yesterFooterBase = $(
    `.${footerClass} .yesteryear-footer .yesteryear-wrapper`
  );
  const yesterFooterInfo = $(`.${footerClass} .yesteryear-footer .info-data`);
  const yesterNavigation = $(".main-theme-footer .footer-navigation");
  const yesterCopy = $(".main-theme-footer .copy-container");

  $(yesterFooterBase).append(footerStructure);
  $(yesterFooterBase).find(".section-b").append(yesterFooterInfo);
  $(yesterFooterBase).find(".section-c").prepend(yesterNavigation);
  $(yesterFooterBase).find(".section-c").append(yesterCopy);

  $(".footer .main-theme-footer").remove();
  $(".footer .southFlorida-footer").remove();
  $(".footer .ag-zone-footer").remove();
}

export { createHeader, createContent, createFooter };
